import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { DatasourceTableState } from '@y42/datasource';
import { SqlModelingTableStore } from './sql-modeling-table.store';

@Injectable({ providedIn: 'root' })
export class SqlModelingTableStoreQuery extends QueryEntity<DatasourceTableState> {
  constructor(protected store: SqlModelingTableStore) {
    super(store);
  }
}
